<dal-shared-ui-navbar
 [activities]="activities$ | async"
 (deleteActivity)="deleteActivity($event)"
 (pauseActivity)="pauseJob($event)"
 (resumeActivity)="resumeJob($event)"
 (cancelActivity)="cancelJob($event)"
 (searchEvent)="handleSearch($event)" (toggleSideNavEvent)="toggleSideNav($event)">
</dal-shared-ui-navbar>
<dal-shared-ui-sidenav [showSideNav]="showSideNav" [elements]="navItems">
  <router-outlet></router-outlet>
</dal-shared-ui-sidenav>

<dal-loader [showLoader$]="this.loading$"></dal-loader>
